import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, Drawer, DrawerProps, List } from "@mui/material";
import { Box } from "@mui/system";
import { CListItemButton, CMenuItemText } from "components/atoms";
import _ from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from "redux/configurations/reduxHooks";
import {
  EXCLUDED_ROUTES_ELANCO,
  EXCLUDED_ROUTES_SCHENKER,
  IMenuItem,
  MENU_ITEMS,
} from "routers/menu";
import { _t } from "utils/i18n";
interface ISideBarProps extends DrawerProps {
  onToggleClick?: () => void;
}

interface IMenuSideBarItem {
  item: IMenuItem;
  open?: boolean;
  isChild?: boolean;
  onClick?: (id: string) => void;
  level?: number;
  disabled?: boolean;
}

const MenuSideBarItem: React.FC<IMenuSideBarItem> = (props) => {
  const { item, disabled } = props;
  const location = useLocation();
  const [openItem, setOpenItem] = React.useState<{ [key: string]: boolean }>(
    {}
  );
  const { t } = useTranslation();
  const pathName = location.pathname;
  const isSelectedItem = pathName.includes(`${item.path}`);
  const isSubItemSelected = item.subItems?.some(
    (item) => item.path === pathName
  );
  const [collapse, setCollapse] = useState(props.open || isSubItemSelected);

  const level = props.level || 0;
  const onClick = (id: string) => {
    let newOpenItem = Object.assign({}, openItem);
    if (!newOpenItem[id]) {
      newOpenItem[id] = true;
    } else {
      newOpenItem[id] = false;
    }
    setOpenItem(newOpenItem);
  };
  if (!item.showInMenu) {
    return null;
  }

  if (
    !_.isEmpty(item.subItems) &&
    !_.isEmpty(_.find(item.subItems, (x) => x.showInMenu))
  ) {
    return (
      <>
        <CListItemButton
          key={item.id}
          isChild={props.isChild}
          onClick={() => {
            if (props.onClick) {
              props.onClick(item.id);
              setCollapse(!collapse);
            }
          }}
          // style={{
          //   display:
          //     warehouseName === "Schenker" && item.id?.includes("bank")
          //       ? "none"
          //       : "flex",
          // }}
        >
          {item.icon}
          <CMenuItemText
            disableTypography
            isChild={props.isChild}
            isChosenParent={pathName.includes(`/${item.id}/`)}
            primary={t(_t(item.label))}
          />
          {collapse ? <ExpandLess /> : <ExpandMore />}
        </CListItemButton>
        <Collapse in={collapse} timeout="auto" unmountOnExit>
          <List>
            {item.subItems?.map((subItem) => {
              return (
                <MenuSideBarItem
                  key={subItem.id}
                  isChild={true}
                  item={subItem}
                  onClick={onClick}
                  level={level + 1}
                  open={openItem[subItem.id]}
                />
              );
            })}
          </List>
        </Collapse>
      </>
    );
  }
  return (
    <CListItemButton
      isSelected={isSelectedItem}
      isChild={props.isChild}
      key={item.id}
      component={Link}
      to={item.path}
      disabled={disabled}
      style={{
        display: disabled ? "none" : "flex",
      }}
    >
      {item.icon}
      <CMenuItemText
        isSelected={isSelectedItem}
        level={level}
        disableTypography
        isChild={props.isChild}
        primary={t(_t(item.label))}
      />
    </CListItemButton>
  );
};

const SIDE_BAR_WIDTH = 260;
const SideBar: React.FC<ISideBarProps> = (props) => {
  const roles = useAppSelector(
    (state) => state.IdentityReducer.authenticate?.roles
  );
  const [openItem, setOpenItem] = React.useState<{ [key: string]: boolean }>(
    {}
  );
  const [openMobile, setOpenMobile] = React.useState(false);

  const onClick = (id: string) => {
    let newOpenItem = Object.assign({}, openItem);
    if (!newOpenItem[id]) {
      newOpenItem[id] = true;
    } else {
      newOpenItem[id] = false;
    }
    setOpenItem(newOpenItem);
  };
  const currentWarehouse = useAppSelector(
    (state) => state.IdentityReducer.currentWarehouse?.description
  ) as string;

  const sideBarRoutes = useMemo(() => {
    const route = getFilterSideBarRoutes(MENU_ITEMS, currentWarehouse, roles);
    return route;
  }, [currentWarehouse]);

  useEffect(() => {
    setOpenMobile(props.open || false);
  }, [props.open]);

  const _renderMenu = () => {
    return (
      <List style={{ width: SIDE_BAR_WIDTH }} dense>
        {sideBarRoutes.map((item) => (
          <MenuSideBarItem
            key={`sidebar_${item.id}`}
            item={item}
            onClick={onClick}
            open={openItem[item.id]}
            // disabled={currentWarehouse === "Elanco"}
          />
        ))}
      </List>
    );
  };
  return (
    <>
      <Drawer
        style={{ width: SIDE_BAR_WIDTH }}
        sx={{ display: { xs: "block", sm: "none" } }}
        variant="temporary"
        onClose={props.onClose!}
        open={openMobile}
      >
        <Logo />
        {_renderMenu()}
      </Drawer>
      <Drawer
        style={{ width: SIDE_BAR_WIDTH }}
        sx={{ display: { xs: "none", sm: "block" } }}
        variant="permanent"
        open
      >
        <Logo />

        {_renderMenu()}
      </Drawer>
    </>
  );
};

const Logo = () => {
  return (
    <Box sx={{ justifyContent: "center", display: "flex", padding: "10px 0" }}>
      <img
        src={require("../assets/images/logo-primary.png")}
        alt={"scs-logo"}
        style={{ width: SIDE_BAR_WIDTH * 0.7 }}
      />
    </Box>
  );
};
export default SideBar;

const getFilterSideBarRoutes = (
  routes: IMenuItem[],
  warehouse: string,
  roles?: string[]
): IMenuItem[] => {
  const _routes = routes.slice();
  const filteredRoute = _routes
    .filter((e) => !e.path || isPathValid(warehouse, e.path))
    .filter((e) => {
      return _.isNil(e.roles) ? true : _.intersection(roles, e.roles).length;
    })
    .filter((e) => e.path || e.subItems?.length);
  return filteredRoute.map((e) => {
    if (e.subItems?.length) {
      return {
        ...e,
        subItems: getFilterSideBarRoutes(_.clone(e.subItems) || [], warehouse, roles),
      };
    } else {
      return e;
    }
  });
};

const isPathValid = (warehouse: string, path?: string) => {
  if (warehouse?.toLowerCase() === "elanco") {
    return EXCLUDED_ROUTES_ELANCO.every((route) => route !== path);
  } else if (warehouse?.toLowerCase() === "schenker") {
    return EXCLUDED_ROUTES_SCHENKER.every((route) => route !== path);
  } else {
    return true;
  }
};
